import React, { useEffect, useState, Fragment } from 'react';
import { Card, Col, Container, Form, Row, Modal, Button } from 'react-bootstrap'
import { serviceGetCompanias, serviceGetDatosImplicado, serviceGetMonedas, serviceParametroFecha, serviceRecepcionar } from '../../../api/api-recuperacion-cobro';
import { dateFormat, formatoMonto, formatoMontoSinPunto, formatoTest, formatoTestUS, moneyPunto, percent, diaAnterior, diaPosterior, isValidParam, formatDateWeb } from '../../../common/Formatos';
import { Auth, LoadingComponent} from 'recupero-comunes'
import Mensajes from '../../mensajes'

const EditCartaCobro = ({ cfg_form, formik, idCaso, idImplicado, codClasCaso, showModal, setShowModal, setCiaImplicado, showToast, responseData, handleCloseToast}) => {
    const { values, errors, touched, handleChange, handleBlur, setFieldValue, setFieldTouched } = formik;    
    const { paisOrganizacion, codMonedaLocal } = Auth.currentUser();
    const [companias, setCompanias] = useState([]);
    const [monedas, setMonedas] = useState([]);
    const [implicadoData, setImplicadoData] = useState("");
    const [fechaSin, setFechaSin]=useState("")
    const [fechaSinIM, setFechaSinIM]=useState("")
    const [valorParametroFecha, setValorParametroFecha]=useState("")

    const [stateMontoCosto, setStateMontoCosto] = useState("");
    const [stateMontoRecobro, setStateMontoRecobro] = useState("");
    const [blur, setBlur] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (showModal && codClasCaso) getMonedas();
    }, [showModal])

    useEffect(() => {
        setBlur(false);
        if (showModal) { getDatosImplicado(); getCompanias() }
    }, [showModal])
    
    useEffect(() => {
        if (blur) setFieldTouched('montoRecobro', stateMontoRecobro >= stateMontoCosto, false);
        else setFieldTouched('montoRecobro', false, false);
    }, [values.montoRecobro, blur])

    useEffect(() => {
        if (responseData?.code === 1) { setStateMontoCosto(""); setStateMontoRecobro("") } 
    }, [responseData])

    useEffect(() => {
        if (Number(values.moneda) === 30001) {
            setStateMontoCosto(formatoMontoSinPunto(stateMontoCosto));
            setStateMontoRecobro(formatoMontoSinPunto(stateMontoRecobro));

            setFieldValue('montoCosto', formatoMonto(formatoMontoSinPunto(stateMontoCosto)));
            setFieldValue('montoRecobro', formatoMonto(formatoMontoSinPunto(stateMontoRecobro)));
        } else {
            setFieldValue('montoCosto', formatoMonto(stateMontoCosto));
            setFieldValue('montoRecobro', formatoMonto(stateMontoRecobro));
        }
    }, [values.moneda])

    const getCompanias = async () => {
        const response = await serviceGetCompanias();
        setCompanias(response);
    }

    const getMonedas = async () => {
        const query = Buffer.from(JSON.stringify({ pais: paisOrganizacion, clasBien: codClasCaso })).toString('base64');
        const response = await serviceGetMonedas(query);

        setMonedas(response);
    }

    const handleChangeMontoCosto = (value) => {
        setFieldValue('montoRecobro', validateMontoMoneda((Number(value) * Number(values.porcConvenio) / 100), 'reset_format'));
        setStateMontoRecobro(validateStateMonto(Number(value) * Number(values.porcConvenio) / 100));
    }

    const handleChangeConvenio = (value) => {
        setBlur(true);

        //setFieldValue('montoRecobro', validateMontoMoneda((Number(stateMontoCosto) * Number(value) / 100), 'reset_format'));
        //setStateMontoRecobro(validateStateMonto(Number(stateMontoCosto) * Number(value) / 100));

        setFieldValue('montoCosto', validateMontoMoneda((Number(stateMontoRecobro) / (Number(value) / 100)), 'reset_format'));
        setStateMontoCosto(validateStateMonto(Number(stateMontoRecobro) / (Number(value) / 100)));
    }

    const handleChangeMontoRecobro = (value) => {
        //if (value !== "") setFieldValue('porcConvenio', parseFloat(Number(value) * 100 / Number(stateMontoCosto)).toFixed(2));
        if (values.porcConvenio) { 
            setFieldValue('montoCosto', validateMontoMoneda((Number(value) / (Number(values.porcConvenio) / 100)), 'reset_format'));
            setStateMontoCosto(validateStateMonto(Number(value) / (Number(values.porcConvenio) / 100)));
        }
    }

    const getDatosImplicado = async () => {
        const query = Buffer.from(JSON.stringify({ idCaso: idCaso, idImplicado: idImplicado })).toString('base64');
        const response = await serviceGetDatosImplicado(query);

        setFieldValue('idCompaniaIM', response[0]?.IdCiaImplicado ?? "");
        setFieldValue('idSiniestroIM', response[0]?.SiniestroIM ?? "");
        setFieldValue('fechaSiniestroIM', dateFormat(response[0]?.FechaSiniestroIMFormat) ?? "");
        setFieldValue('fechaCarta', dateFormat(response[0]?.FechaEnvioCartaCobroFormat) ?? "");
        setFieldValue('moneda', response[0]?.CodMonedaRecobro ?? codMonedaLocal);
        setFieldValue('montoCosto', response[0]?.MontoCosto ? validateMontoMoneda(response[0]?.MontoCosto, 'format') : "");
        setFieldValue('porcConvenio', response[0]?.PorConvenido ?? "");
        setFieldValue('montoRecobro', response[0]?.MontoRecobro ? validateMontoMoneda(response[0]?.MontoRecobro, 'format') : "");

        //setMontoCosto(response[0]?.MontoCosto ? response[0]?.MontoCosto : "");
        setStateMontoCosto(response[0]?.MontoCosto ? response[0]?.MontoCosto : "");
        setStateMontoRecobro(response[0]?.MontoRecobro ? response[0]?.MontoRecobro : "");
        setImplicadoData(response && response.length > 0 ? response[0] : null);
        setCiaImplicado(response[0]?.CiaImplicado ? response[0]?.CiaImplicado : "");

        let queryP = Buffer.from(JSON.stringify({"rutcia":0,"parametro":34})).toString('base64')
        const responseP = await serviceParametroFecha(queryP);
        setValorParametroFecha(responseP.valorParametro);

        setFechaSin(isValidParam(response[0].FechaSiniestroFormat) ? response[0].FechaSiniestroFormat : "")
    }

    const handleFocusBlur = (action, type, value) => {
        if (action === "focus") {
            setBlur(false);

            if (type === "montoCosto") setFieldValue([type], stateMontoCosto);
            else setFieldValue([type], validateStateMonto(stateMontoRecobro));
        }
        else {
            setBlur(true);

            if (type === "montoCosto") setFieldValue([type], validateMontoMoneda(stateMontoCosto, 'format'));
            else setFieldValue([type], validateMontoMoneda(stateMontoRecobro, 'format'));
        }
    }

    const validateMontoMoneda = (value, action) => {
        if (action === 'format') return formatoTest(value, true);
        else {
            if (Number(values.moneda) === 30001) return formatoTest(value, false);
            else return formatoTest(value, true);
        }
    }

    const validateStateMonto = (value) => {
        if (Number(values.moneda) === 30001) return formatoTestUS(value, false);
        else return formatoTestUS(value, true);
    }
    const handleClose = () => {
        setShowModal(false); formik.resetForm();
    }
    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showModal} onHide={setShowModal} size='xl'>
                <Card>
                    <Card.Header as='h6' style={{ backgroundColor: "rgb(209, 242, 235)", color: 'color: rgb(255, 255, 255)' }}>
                        Editar {cfg_form && cfg_form["aprobobjcartacobrotercero-subtitle1"]}
                        {` (${implicadoData?.IdImplicado}: ${implicadoData?.NombreImplicado} - ${implicadoData?.Patente})` }                    
                    </Card.Header>

                    <Card.Body>
                        <Container>
                            <Row>
                                <Col md='3' className='mb-2'>
                                    <Form.Label className="label is_required">
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-compania"]}
                                    </Form.Label>
                                    <Form.Select
                                        name='idCompaniaIM'
                                        value={values.idCompaniaIM}
                                        onChange={e => {
                                            handleChange(e);
                                            let selectedId = parseInt(e.target.value);
                                            let selectedCia = companias?.find(c => c.id === selectedId);
                                            setCiaImplicado(selectedCia.nombre)     
                                        }}
                                        onBlur={handleBlur}>

                                        <option value={''}>Seleccione...</option>
                                        {companias && companias
                                            .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                        }
                                    </Form.Select>
                                    {errors.idCompaniaIM && touched.idCompaniaIM &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.idCompaniaIM}
                                        </Form.Text>
                                    }
                                </Col>
                                <Col md='3' className='mb-2'>
                                    <Form.Label className="label is_required">
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-sinitercero"]}
                                    </Form.Label>
                                    <Form.Control
                                        name='idSiniestroIM'
                                        value={values.idSiniestroIM}
                                        onChange={e => handleChange(e)}
                                        onBlur={handleBlur}>
                                    </Form.Control>
                                    {errors.idSiniestroIM && touched.idSiniestroIM &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.idSiniestroIM}
                                        </Form.Text>
                                    }
                                </Col>
                                <Col md='3' className='mb-2'>
                                    <Form.Label className="label">
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-fechasinitro"]}
                                    </Form.Label>
                                    <Form.Control
                                        type="date"
                                        name='fechaSiniestroIM'
                                        value={values.fechaSiniestroIM}
                                        onChange={e => {handleChange(e); setFechaSinIM(e.target.value)}}
                                        onBlur={handleBlur}
                                        min={ fechaSin && valorParametroFecha && diaAnterior(fechaSin, valorParametroFecha)}
                                        max={ fechaSin && valorParametroFecha && diaPosterior(fechaSin, valorParametroFecha)}>
                                    </Form.Control>
                                    {errors.fechaSiniestroIM && touched.fechaSiniestroIM &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.fechaSiniestroIM}
                                        </Form.Text>
                                    }
                                </Col>
                                <Col md='3' className='mb-2'>
                                    <Form.Label className="label is_required">
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-fecharecepcarta"]}
                                    </Form.Label>
                                    <Form.Control
                                        type="date"
                                        name='fechaCarta'
                                        value={values.fechaCarta}
                                        onChange={e => handleChange(e)}
                                        onBlur={handleBlur}
                                        min={fechaSinIM}>
                                    </Form.Control>
                                    {errors.fechaCarta && touched.fechaCarta &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.fechaCarta}
                                        </Form.Text>
                                    }
                                </Col>

                                <Col md='3' className='mb-2'>
                                    <Form.Label className="label is_required">
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-moneda"]}
                                    </Form.Label>
                                    <Form.Select
                                        name='moneda'
                                        value={values.moneda}
                                        onChange={e => handleChange(e)}
                                        onBlur={handleBlur}>

                                        <option value={''}>Seleccione...</option>
                                        {monedas && monedas
                                            .map((m) => (<option key={m.id} value={m.id}>{m.nombre}</option>))
                                        }
                                    </Form.Select>
                                    {errors.moneda && touched.moneda &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.moneda}
                                        </Form.Text>
                                    }
                                </Col>
                                <Col md='3' className='mb-2'>
                                    <Form.Label className="label is_required">
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-montorecobro"]}
                                    </Form.Label>
                                    <Form.Control
                                        name='montoRecobro'
                                        value={values.montoRecobro}
                                        onChange={e => { handleChange(e); handleChangeMontoRecobro(e.target.value); setStateMontoRecobro(e.target.value) }}
                                        onBlur={e => { handleBlur(e); handleFocusBlur('blur', 'montoRecobro', e.target.value) }}
                                        onFocus={e => handleFocusBlur('focus', 'montoRecobro', e.target.value)}
                                        onKeyPress={(e) => moneyPunto(e, Number(values.moneda) !== 30001)}>
                                    </Form.Control>
                                    {errors.montoRecobro && touched.montoRecobro &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.montoRecobro}
                                        </Form.Text>
                                    }
                                </Col>
                                <Col md='3' className='mb-2'>
                                    <Form.Label className="label is_required">
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-porcconvenio"]}
                                    </Form.Label>
                                    <Form.Control
                                        name='porcConvenio'
                                        maxLength={5}
                                        value={values.porcConvenio}
                                        onChange={e => { handleChange(e); handleChangeConvenio(e.target.value) }}
                                        onBlur={handleBlur}
                                        onKeyPress={(e) => percent(e)}>
                                    </Form.Control>
                                    {errors.porcConvenio && touched.porcConvenio &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.porcConvenio}
                                        </Form.Text>
                                    }
                                </Col>
                                <Col md='3' className='mb-2'>
                                    <Form.Label className="label is_required">
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-montoneto"]}
                                    </Form.Label>
                                    <Form.Control
                                        name='montoCosto'
                                        value={values.montoCosto}
                                        onChange={e => { handleChange(e); handleChangeMontoCosto(e.target.value); setStateMontoCosto(e.target.value) }}
                                        onBlur={e => { handleBlur(e); handleFocusBlur('blur', 'montoCosto', e.target.value) }}
                                        onFocus={e => handleFocusBlur('focus', 'montoCosto', e.target.value)}
                                        onKeyPress={(e) => moneyPunto(e, Number(values.moneda) !== 30001)}
                                        disabled>
                                    </Form.Control>
                                    {errors.montoCosto && touched.montoCosto &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.montoCosto}
                                        </Form.Text>
                                    }
                                </Col>                            
                            </Row>
                        </Container>
                    </Card.Body>     
                    <Card.Footer style={{ display: 'flex', justifyContent: 'right', gap: '8px' }}>
                        <Button className='w-auto' variant='outline-info' onClick={handleClose}>
                            {cfg_form && cfg_form["aprobobjcartacobrotercero-btn-cerrar-modaledc"]}
                        </Button>
                        <Button type="w-auto" className='w-auto buttonLetter' variant='danger' onClick={formik.handleSubmit}>
                            {cfg_form && cfg_form["aprobobjcartacobrotercero-btn-act-modaledc"]}
                        </Button>
                    </Card.Footer>      
                    
                    {showToast && 
                        <Mensajes
                            showToast={showToast}
                            handleCloseToast={handleCloseToast}
                            delay={3000}
                            responseData={responseData}
                        ></Mensajes>
                    }             
                </Card>
            </Modal>
            <style type='text/css'>
                {`
                    .is_required:after {
                        content: "*";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                    .not_required:after {
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                    .label {
                        font-weight: bold;
                        font-size: 14px;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default EditCartaCobro;